"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Bar_Chart = void 0;

var d3 = void 0;
var nvd3 = void 0;

d3 = require("d3");

nvd3 = require("nvd3");

Bar_Chart = function () {
  Bar_Chart.prototype.graph = void 0;

  Bar_Chart.prototype.remove = function () {
    return d3.selectAll(this.graph + " > *").remove();
  };

  Bar_Chart.prototype.render = function (data, format) {
    var graph = void 0;
    graph = this.graph;
    this.remove();
    return nv.addGraph(function () {
      var chart = void 0;
      chart = nv.models.discreteBarChart().x(function (d) {
        return d[0];
      }).y(function (d) {
        return d[1];
      }).staggerLabels(false).tooltips(true).showValues(false).showYAxis(false).transitionDuration(350).color(d3.scale.ordinal().range(["#4c4c4c"]));
      chart.xAxis.showMaxMin(false).tickFormat(function (d) {
        return d3.time.format(format)(new Date(d));
      });
      chart.tooltipContent(function (key, y, e, _ref) {
        var series = _ref.series;

        data = series.values[y - 1];
        return "<p>" + e + "</p>";
      });
      chart.valueFormat(d3.format(".0f"));
      return d3.select(graph).datum(data).transition().duration(500).call(chart);
    });
  };

  function Bar_Chart(graph, data, format) {
    this.graph = graph;
    this.render(data, format);
  }

  return Bar_Chart;
}();

exports.default = Bar_Chart;